import React, { useState, useEffect  } from 'react';
import authHeader from '../services/AuthHeader';
import axios from 'axios';
import AddBallot from './AddBallot';
import DragDrop from './DragDrop';
import {
  MdOutlineAdd,
  MdOutlineRemove,
} from 'react-icons/md';
//import { useImmer } from "use-immer";

const EditElection = ({ electionData, ballotData, setBallotData }) => {
  let stateVars = {};
  const [partyData, ] = useState([]);
  const [showAddBallot] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [ballotRestrictions, ] = useState([]);
  const [isLocked, setIsLocked] = useState(false);
  const electionTitle = ballotData && ballotData.electionName
    ? ballotData.electionName
    : electionData && electionData[0] && electionData[0].electionName
      ? electionData[0].electionName
      : 'Election';

  /* Get election data, use stateVars as dynamic var to maintain state for each ballot */
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_BASE + 'election/', {
        headers: authHeader(),
      })
      .then((res) => {
        setBallotData(res.data);
        setIsLocked(res.data.locked);
        res.data.allBallots.map((ballot) => {
          stateVars['ib_' + ballot.ballotId] = ballot;
          return 1;
        });
        setRerender(false);
      });
  }, [rerender]);

  const [state, setState] = useState(stateVars);

  /* update order after deletion of ballot */
  const reorder = (tempData, ballotIndex) => {
    for (var j = ballotIndex; j < tempData.length; j++){
      tempData[j].sortOrder = j;
    }
     axios
      .put(process.env.REACT_APP_API_BASE + 'reorderballots/1', tempData, {
        headers: authHeader(),
      }) 
    return tempData;
  };

  /* Add new individual ballot */
  const addNewBallot = () => {
    const newBallotLoc = ballotData.allBallots.length + 1;
    const newBallot = {
      ElectionId: ballotData.electionId,
      BallotName: 'Enter ballot',
      NumberChosen: 1,
      WriteIn: false,
      SortOrder: newBallotLoc,
      Referendum: false,
    };
    let newBallotRestrictions = {
      BallotId: 0,
      BallotRestrictionTypeId: 1,
      BallotRestrictionDetail: null,
    };
    axios
      .post(process.env.REACT_APP_API_BASE + 'ballot/', newBallot, {
        headers: authHeader(),
      })
      .then((resBallot) => {
        newBallotRestrictions = {
          ...newBallotRestrictions,
          BallotId: resBallot.data,
        };
        axios
          .post(
            process.env.REACT_APP_API_BASE + 'ballotRestrictions/',
            newBallotRestrictions,
            {
              headers: authHeader(),
            }
          )
          .then(console.log('add'),setRerender(true));
        setState((prevState) => ({
          ...prevState,
          ['bg_' + newBallotLoc]: true,
        }));
      });
  };

  if (isLocked) {
    return (
      <div className='App'>
        <b>Election is Active and Cannot Be Edited</b>
      </div>
    );
  }

  return (
    <>
      <div className='bg-wrapper-header'>
        <div className='bg-left-header'>
          <h1 className='h2'>Edit Election</h1>
          <h2 className='h3'>{electionTitle}</h2>
        </div>
        <div className='bg-right-header'>
        </div>
      </div>

      {ballotData.allBallots ? (
        <div className='margin-ballot'>
            <DragDrop ballotData={ballotData} setBallotData={setBallotData} />
        </div>
      ) : (
        <img src='spinner.gif' alt='Loading election ballot editor' />
      )}

      <div className='bg-wrapper-header'>
        <div className='bg-left-header'>
          {showAddBallot ? (
            <div
              style={{ float: 'right', marginRight: '30px', marginTop: '5px' }}
            >
              Done
            </div>
          ) : (
            <div
              style={{ float: 'right', marginRight: '30px', marginTop: '5px' }}
            >
              Add Another Ballot
            </div>
          )}
        </div>
        <div className='bg-right-header'>
          <button
            type='button'
            className='icon-button'
            aria-label='Add another ballot'
            onClick={() => addNewBallot()}
          >
            {showAddBallot ? (
              <MdOutlineRemove size={40} aria-hidden='true' />
            ) : (
              <MdOutlineAdd size={40} title='add new ballot' aria-hidden='true' />
            )}
          </button>
        </div>
      </div>
      {showAddBallot ? (
        <AddBallot
          partyData={partyData}
          ballotRestrictions={ballotRestrictions}
        />
      ) : (
        ''
      )}
    </>
  );
};
export default EditElection;
